module.exports = __webpack_public_path__ + "bc3f4364b108550db3ed71ade7e178fd.png";